// Vendor
import { createAction, props } from '@ngrx/store';
export const setChartData = createAction('[Fund Chart] Set chart data', props());
